import LayerMenuPanel from './LayerMenuPanel';
import { on } from '../../utils/EventsBus';
import { CustomEvents } from '../../utils/CustomEvents';

export default class MenuItem {
  get CLASSNAMES() {
    return {
      active: 'active',
      activeLayersContainer: 'active-layers',
      divider: 'header-divider',
    };
  }
  constructor(itemEl, layersContainerEl) {
    this.item = itemEl;
    this.panel = null;
    this.layersContainer = layersContainerEl;
    this.header = document.querySelector('header');
    if (this.item) {
      this.init();
    }

    this.$on = on;
  }
  init() {
    try {
      this.checkForPanel();
    } catch (e) {
      console.error(e);
    }
  }

  checkForPanel() {
    if (!this.layersContainer) {
      throw `No layers container declared at constructor`;
    }
    if (
      this.item.dataset.panelTarget &&
      this.item.dataset.panelTarget.length > 0
    ) {
      let target = this.item.dataset.panelTarget;
      let panelEl = this.layersContainer.querySelector(
        ` [data-menu-panel="${target}"]`
      );
      if (panelEl) {
        this.panel = new LayerMenuPanel(panelEl);
        this.startListener();
      }
    }
  }
  isDesktop() {
    return window.matchMedia('(min-width:1024px)').matches;
  }
  startListener() {
    // check if is desktop
    if (this.isDesktop()) {
      this.item.addEventListener('mouseenter', e => {
        e.stopPropagation();
        e.preventDefault();
        if (this.isDesktop()) {
          // add timeout to avoid immediate open when search is also open
          this.hoverTimeout = setTimeout(() => {this.showPanel()}, 300);
        }
      });
      this.item.addEventListener('mouseleave', e => {
        e.stopPropagation();
        e.preventDefault();
        if (this.isDesktop()) {
          // clear timeout on enter, don't open
          clearTimeout(this.hoverTimeout);
          if (!this.panel.checkChild(e.relatedTarget)) {
            this.hidePanel();
          }
        }
      });
    } else {
      // mobile
      let detectTap;
      this.item.addEventListener('touchstart', e => {
        detectTap = true; // Detects all touch events
      });
      this.item.addEventListener('touchmove', e => {
        detectTap = false; // Excludes the scroll events from touch events
      });
      this.item.addEventListener('touchend', e => {
        e.preventDefault();
        if (e.type == "click") detectTap = true; // Detects click events
        if (detectTap){
          // Here you can write the function or codes you want to execute on tap
          this.showPanel();
        }
      });
      if (!('ontouchstart' in window)) {
        this.item.addEventListener('click', e => {
          e.preventDefault();
          this.showPanel();
        });
      }
      let ctx = this;
      on(CustomEvents.MENU_EVENTS.showMenu, () => {
        if (!ctx.isDesktop()) {
          const location = window.location.href;
          const href = ctx.item.querySelector('a').href;
          if (location.includes(href)) {
            this.showPanel();
          }
        }
      })
    }
  }
  on(event, callback) {
    if (!this.panel) {
      return;
    }
    this.item.addEventListener(event, callback);
  }
  setActive(bool = true) {
    if (typeof bool !== 'boolean') {
      return;
    }
    this.item.classList.toggle(this.CLASSNAMES.active, bool);
  }
  showPanel() {
    if (!this.panel || this.panel.isActive) {
      return;
    }
    this.setActive();
    this.panel.showLayer();
    this.header.classList.add(this.CLASSNAMES.divider);
    this.togglePanelsContainer(this.panel.isActive);
    this.panel.onLeave(e => {
      if (e.relatedTarget === this.item) {
        return;
      }
      this.hidePanel();
    });
    this.panel.whenBack(() => {
      this.hidePanel();
    });
  }
  hidePanel() {
    if (!this.panel) {
      return;
    }
    this.setActive(false);
    this.panel.hideLayer();
    if (!this.panel.isActive) {
      this.togglePanelsContainer(this.panel.isActive);
    }
  }
  togglePanelsContainer(bool = true) {
    if (typeof bool !== 'boolean') {
      return;
    }
    this.layersContainer.classList.toggle(this.CLASSNAMES.activeLayersContainer, bool);
  }
}
